<div [class]="skinName">
    <div id="stripe-card" class="d-flex j-center">
        <img class="m-10" src="branding/theme/assets/static_assets/ic-powered-by-stripe.svg">
        <img class="m-10" src="branding/theme/assets/static_assets/ic-secure-ssl-payment.svg">
    </div>
</div>